import "./AICopilot.css";
import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import ServiceFooter from "../../ServiceFooter";
import {
  aiCopilotBenefits,
  aiCoPilotCards,
  aiCoPilotCardsTwo,
  aiCopilotIndustries,
  aiCoPilotKeyCards,
  aiCopilotProcessSteps,
  aiCopilotUseCases,
  aiTrends,
  costFactors,
  hireFactors,
  technologiesData,
} from "./data";
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Marquee from "react-fast-marquee";

const AICopilot = () => {
  // use case
  const [isPrevUseDisabled, setIsPrevUseDisabled] = useState(true);
  const [isNextUseDisabled, setIsNextUseDisabled] = useState(false);
  const [techTab, setTechTab] = useState("machinelearning");

  const handleUseChange = (UseSwiper) => {
    setIsPrevUseDisabled(UseSwiper.isBeginning);
    setIsNextUseDisabled(UseSwiper.isEnd);
  };

  // process
  const [isPrevProcessDisabled, setIsPrevProcessDisabled] = useState(true);
  const [isNextProcessDisabled, setIsNextProcessDisabled] = useState(false);

  const handleProcessChange = (ProcessSwiper) => {
    setIsPrevProcessDisabled(ProcessSwiper.isBeginning);
    setIsNextProcessDisabled(ProcessSwiper.isEnd);
  };

  const handleTechClick = (tab) => {
    setTechTab(tab);
  };

  const activeData =
    technologiesData.find((tab) => tab.id === techTab)?.data || [];

  return (
    <>
      <NewHead />

      <Helmet>
        <title>AI Copilot Development Company</title>

        <meta name="title" content="AI Copilot Development Company" />
        <meta
          name="description"
          content="If you're ready to build an AI copilot. Start by consulting the best AI copilot development company in the industry."
        />

        <meta property="og:title" content="AI Copilot Development Company" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/ai-copilot-development-company"
        />
      </Helmet>

      <main className="ai_copilot_main">
        {/* hero */}
        <article className="ai_co_hero ai_co_mb_80">
          <div className="ai_co_hero_cnts">
            <h1 className="ai_co_title">
              {" "}
              <span className="ai_co_span">AI Copilot</span> Development Company
            </h1>
            <p className="ai_co_content">
              Build Your Smart Digital Assistant with our advanced AI Copilot
              Development Service.
            </p>
            <div className="ai_co_hero_btn_wrap">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="ai_co_hero_btn"
              >
                Get Your AI Copilot
              </button>
            </div>
          </div>

          <div className="ai_co_bg_grad"></div>
        </article>

        <div className="ai_co_grad_outer">
          {/* about */}
          <article className="ai_co_about ">
            <div className="primary__landing-content-container">
              <h3 className="ai_co_subtitle text-center">
                What is <span className="ai_co_span"> an AI Copilots?</span>
              </h3>
            </div>
          </article>

          <div className="primary__landing-content-container ai_co_mb_80">
            <div className="az-about-content ai_co_abt_content">
              <p>
                <span>
                  AI copilots are intelligent digital assistants built using
                  advanced AI technologies such as machine learning, natural
                  language processing (NLP), and generative AI. These copilots
                  can understand user input, learn from data, and provide
                  contextual assistance, much like a real-life copilot helps a
                  pilot navigate a flight. Whether it’s helping a customer
                  support agent resolve queries faster, or assisting developers
                  in writing cleaner code, AI copilots are transforming the way
                  we work.
                </span>
              </p>
            </div>
          </div>

          {/* core features */}
          <article className="primary__landing-content-container ai_co_mb_80">
            <div className="ai_co_core">
              <h3 className="ai_co_subtitle text-center">
                <span className="ai_co_span ai_co_block">Core Features </span>
                of a Powerful AI Copilot
              </h3>
              <p className="ai_co_subcontent ai_co_cr_content">
                When partnering with an AI copilot development company, ensure
                your AI solution includes the following features
              </p>

              <div className="ai_co_cr_wrap">
                {aiCoPilotCards.map((item) => (
                  <div className="ai_co_cr_card">
                    <div className="ai_co_cr_img_wrap">
                      <img
                        src={item.img}
                        alt="AI Copilot Development Company"
                        className="ai_co_cr_img"
                      />
                      <img
                        src={item.hoverImg}
                        alt="AI Copilot Development Company"
                        className="ai_co_hv"
                      />
                    </div>
                    <h5>{item.title}</h5>
                  </div>
                ))}
              </div>

              <div className="ai_co_cr_wrap cr_wrap_two">
                {aiCoPilotCardsTwo.map((item) => (
                  <div className="ai_co_cr_card">
                    <div className="ai_co_cr_img_wrap">
                      <img
                        src={item.img}
                        alt="AI Copilot Development Company"
                        className="ai_co_cr_img"
                      />
                      <img
                        src={item.hoverImg}
                        alt="AI Copilot Development Company"
                        className="ai_co_hv"
                      />
                    </div>
                    <h5>{item.title}</h5>
                  </div>
                ))}
              </div>
            </div>
          </article>

          <div className="ai_co_abt_grad"></div>
        </div>

        {/* about company */}
        <article className="primary__landing-content-container ai_co_mb_80">
          <div className="row mx-0 g-4">
            <div className="col-lg-5">
              <h3 className="ai_co_subtitle">
                <span className="ai_co_span">What is an AI Copilot </span>
                Development Company?
              </h3>
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="ai_co_btn mt-1 mt-lg-3"
              >
                Talk to Our AI Experts
              </button>
            </div>
            <div className="col-lg-7">
              <p className="ai_co_subcontent">
                An AI copilot development company specializes in building
                intelligent digital assistants that integrate seamlessly with
                your tools, platforms, and workflows. These companies bring
                together data scientists, AI engineers, and software developers,
                UX designers to deliver advanced AI solutions. From ideation to
                deployment, an AI copilot development company ensures that your
                digital assistant is scalable, secure, and aligned with your
                business objectives.
              </p>
            </div>
          </div>
        </article>

        {/* need */}
        <article className="ai_co_need ai_co_mb_80">
          <div className="primary__landing-content-container">
            <div className="row  g-5 ai_co_need_row">
              <div className="col-lg-5">
                <img
                  src={require("../../../image/aicopilot/need.webp")}
                  alt="AI Copilot Development Company"
                />
              </div>
              <div className="col-lg-7">
                <h3 className="ai_co_subtitle ">
                  <span className="ai_co_span">Why Do You Need </span>
                  an AI Copilot ?
                </h3>
                <p className="ai_co_subcontent">
                  The global shift toward automation and smart workflows is
                  accelerating. Businesses that adopt AI copilots early gain a
                  competitive edge through agility, efficiency, and innovation.
                  Working with a professional AI copilot development company
                  ensures that your AI assistant is designed to scale, secure,
                  and adapt to future needs. Whether you're a startup looking to
                  boost internal productivity or an enterprise aiming to disrupt
                  markets, AI copilots are the future.
                </p>
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="ai_co_btn mt-1 mt-lg-3"
                >
                  Try It Today
                </button>
              </div>
            </div>
          </div>
        </article>

        {/* key features */}
        <article className="primary__landing-content-container ai_co_mb_80">
          <div className="ai_co_key">
            <h3 className="ai_co_subtitle text-center">
              <span className="ai_co_span">Key Features of </span>
              AI Copilot Applications
            </h3>
            <p className="ai_co_subcontent ai_co_key_content">
              Top AI copilot solutions developed by professional AI copilot
              development companies come with the following features
            </p>

            <div className="row g-4 ai_co_key_row">
              {aiCoPilotKeyCards.map((item, index) => (
                <div className="col-lg-4 col-sm-6" key={index}>
                  <div className="ai_co_key_card">
                    <img src={item.img} alt="AI Copilot Development Company" />
                    <h5>{item.title}</h5>
                  </div>
                </div>
              ))}
            </div>

            <div className="d-flex align-items-center justify-content-center mt-4">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="ai_co_btn mt-1 mt-lg-3"
              >
                Discover More
              </button>
            </div>
          </div>
        </article>

        {/* about company */}
        <article className="primary__landing-content-container ai_co_mb_80">
          <div className="row mx-0 g-4">
            <div className="col-lg-5">
              <h3 className="ai_co_subtitle">
                <span className="ai_co_span">Integrating AI Copilot </span>
                Features into Your Software
              </h3>
            </div>
            <div className="col-lg-7">
              <p className="ai_co_subcontent">
                Incorporating AI copilot functionality into your existing
                software can transform the way users interact with your product
                making workflows faster, smarter, and more intuitive. From smart
                suggestions and automation to real-time insights and decision
                support, AI copilots are becoming essential components in modern
                apps.
              </p>
            </div>
          </div>
        </article>

        {/* benefits */}
        <article className="ai_co_benefits ai_co_mb_80">
          <div className="primary__landing-content-container">
            <h3 className="ai_co_subtitle ai_co_ben_title">
              <span className="ai_co_span">Benefits of Hiring </span>
              an AI Copilot Development Company
            </h3>
            <p className="ai_co_subcontent ai_co_ben_content">
              Working with a specialized AI copilot development company offers
              multiple advantages
            </p>

            <div className="row g-4 ai_co_ben_row">
              {aiCopilotBenefits.map((item, index) => (
                <div className="col-lg-3 col-sm-6" key={index}>
                  <div className="ai_co_ben_outer">
                    <div className="ai_co_ben_inner">
                      <img
                        src={item.img}
                        alt="AI Copilot Development Company"
                        className="ai_co_ben_img"
                      />
                      <h5>{item.title}</h5>
                      <p>{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </article>

        {/* use case */}
        <article className="primary__landing-content-container ai_co_mb_80">
          <div className="row g-4">
            <div className="col-lg-5">
              <h3 className="ai_co_subtitle">
                <div className="ai_co_span">Popular Use Cases </div>
                for AI Copilot Development
              </h3>
            </div>
            <div className="col-lg-1 ai_co_mob_none"></div>
            <div className="col-lg-6">
              <p className="ai_co_subcontent">
                A dedicated AI copilot development company can design and build
                intelligent copilots designed to a wide range of industries and
                business functions.
              </p>
            </div>
          </div>

          <>
            <Swiper
              className="ai_co_use_swiper"
              spaceBetween={30}
              slidesPerView={4}
              modules={[Navigation]}
              navigation={{
                prevEl: ".cr_doc_prev",
                nextEl: ".cr_doc_nxt",
              }}
              breakpoints={{
                320: { slidesPerView: 1, spaceBetween: 10 },
                576: { slidesPerView: 2, spaceBetween: 20 },
                768: { slidesPerView: 2, spaceBetween: 30 },
                992: { slidesPerView: 3, spaceBetween: 40 },
                1200: { slidesPerView: 4, spaceBetween: 30 },
              }}
              onSlideChange={handleUseChange}
              onReachBeginning={() => setIsPrevUseDisabled(true)}
              onReachEnd={() => setIsNextUseDisabled(true)}
              onFromEdge={() => {
                setIsPrevUseDisabled(false);
                setIsNextUseDisabled(false);
              }}
            >
              {aiCopilotUseCases.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="ai_co_use_card">
                    <img src={item.img} alt="AI Copilot Development Company" />
                    <h5>{item.title}</h5>
                    <ul>
                      {item.features.map((feature, i) => (
                        <li key={i}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="fd-step-btn-wrap">
              <button
                className={`cr_doc_prev ${isPrevUseDisabled ? "disabled" : ""}`}
                style={{
                  color: isPrevUseDisabled ? "#ffffff8f" : "#fff",
                  cursor: isPrevUseDisabled ? "not-allowed" : "pointer",
                }}
              >
                <i className="fa-solid fa-arrow-left"></i>
              </button>
              <button
                className={`cr_doc_nxt ${isNextUseDisabled ? "disabled" : ""}`}
                style={{
                  color: isNextUseDisabled ? "#ffffff8f" : "#fff",
                  cursor: isNextUseDisabled ? "not-allowed" : "pointer",
                }}
              >
                <i className="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </>
        </article>

        <div className="ai_co_grad_outer overflow-hidden">
          {/* industries */}
          <article className="ai_co_industry ai_co_mb_80">
            <div className="primary__landing-content-container">
              <h3 className="ai_co_subtitle ai_co_industry_title">
                <span className="ai_co_span">Industries Benefiting </span>
                from AI Copilot Development Company
              </h3>
              <p className="ai_co_subcontent text-center">
                Virtually every industry can benefit from AI copilots. The top
                sectors include
              </p>
            </div>

            <Marquee
              speed={60}
              autoFill
              pauseOnHover
              className="ai_co_ind_marquee"
            >
              {aiCopilotIndustries.map((item, index) => (
                <div className="ai_co_marquee_card_outer" key={index}>
                  <div className="ai_co_marquee_card">
                    <img src={item.img} alt="AI Copilot Development Company" />
                    <h5>{item.title}</h5>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </Marquee>
          </article>

          {/* process */}
          <article className="primary__landing-content-container ai_co_mb_80">
            <h3 className="ai_co_subtitle text-center">
              The AI Copilot{" "}
              <span className="ai_co_span">Development Process</span>
            </h3>
            <p className="ai_co_subcontent text-center">
              A typical AI copilot development process includes
            </p>

            <div className="row">
              <div className="col-lg-4"></div>
            </div>

            <>
              <Swiper
                className="ai_co_use_swiper"
                spaceBetween={30}
                slidesPerView={3}
                modules={[Navigation]}
                navigation={{
                  prevEl: ".ai_co_process_prev",
                  nextEl: ".ai_co_process_nxt",
                }}
                breakpoints={{
                  320: { slidesPerView: 1, spaceBetween: 10 },
                  576: { slidesPerView: 2, spaceBetween: 20 },
                  768: { slidesPerView: 2, spaceBetween: 30 },
                  992: { slidesPerView: 3, spaceBetween: 40 },
                  1200: { slidesPerView: 3, spaceBetween: 20 },
                }}
                onSlideChange={handleProcessChange}
                onReachBeginning={() => setIsPrevProcessDisabled(true)}
                onReachEnd={() => setIsNextProcessDisabled(true)}
                onFromEdge={() => {
                  setIsPrevProcessDisabled(false);
                  setIsNextProcessDisabled(false);
                }}
              >
                {aiCopilotProcessSteps.map((step, index) => (
                  <SwiperSlide key={index}>
                    <div className="ai_co_process_card">
                      <img
                        src={step.img}
                        alt="AI Copilot Development Company"
                      />
                      <h5>{step.title}</h5>
                      <p>{step.desc}</p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              <div className="fd-step-btn-wrap">
                <button
                  className={`ai_co_process_prev ${
                    isPrevProcessDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevProcessDisabled ? "#ffffff8f" : "#fff",
                    cursor: isPrevProcessDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  <i className="fa-solid fa-arrow-left"></i>
                </button>
                <button
                  className={`ai_co_process_nxt ${
                    isNextProcessDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextProcessDisabled ? "#ffffff8f" : "#fff",
                    cursor: isNextProcessDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  <i className="fa-solid fa-arrow-right"></i>
                </button>
              </div>
            </>
          </article>

          <div className="ai_co_pr_grad"></div>
        </div>

        <div className="ai_co_grad_outer">
          {/* technologies */}
          <article className="primary__landing-content-container ai_co_mb_80">
            <article className="ai_co_tech ">
              <h3 className="ai_co_subtitle ai_co_ben_title">
                <span className="ai_co_span">Technologies Used </span>
                by AI Copilot Development Company
              </h3>
              <p className="ai_co_subcontent text-center">
                Leading AI copilot development companies use the latest tech
                stack, including
              </p>

              <div className="row g-4 ai_co_tech_row">
                <div className="col-lg-3 col-md-5">
                  <div className="ai_co_tech_lft">
                    {technologiesData.map((tab) => (
                      <button
                        key={tab.id}
                        onClick={() => handleTechClick(tab.id)}
                        className={`ai_co_tech_btn ${
                          techTab === tab.id ? "active" : ""
                        }`}
                      >
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="col-lg-9 col-md-7">
                  <div className="ai_co_tech_rgt">
                    <div className="ai_co_tech_rgt_wrap">
                      <div className="row g-4">
                        {activeData.map((tech) => (
                          <div
                            className="col-xl-4 col-md-12 col-sm-6"
                            key={tech.id}
                          >
                            <div className="ai_tech_card">
                              <img
                                src={tech.icon}
                                alt="AI Copilot Development Company"
                              />
                              <h6>{tech.title}</h6>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </article>

          {/* trends */}
          <article className="primary__landing-content-container ai_co_mb_80">
            <h3 className="ai_co_subtitle text-center">
              <span className="ai_co_span">Trends in AI </span>
              Copilot Development
            </h3>
            <p className="ai_co_subcontent text-center">
              AI copilots will continue evolving with trends such as
            </p>

            <div className="row g-4 ai_co_trend_row">
              {aiTrends.map((trend, index) => (
                <div className="col-lg-4 col-sm-6" key={index}>
                  <div className="ai_co_trend_card">
                    <img src={trend.img} alt="AI Copilot Development Company" />
                    <h6>{trend.title}</h6>
                  </div>
                </div>
              ))}
            </div>

            <p className="ai_co_subcontent ai_co_trend_content ">
              Choosing the right AI copilot development company will ensure that
              your business stays ahead of these trends.
            </p>
          </article>

          <div className="ai_co_tr_grad"></div>
        </div>

        {/* build */}
        <article className="ai_co_building ai_co_mb_80">
          <div className="primary__landing-content-container">
            <div className="row mx-0 g-4">
              <div className="col-lg-4">
                <h3 className="ai_co_subtitle">
                  <span className="ai_co_span">Building Your </span>
                  Own AI Copilot
                </h3>
              </div>
              <div className="col-lg-8">
                <p className="ai_co_subcontent">
                  Today, users don’t just want tools, they want assistants. They
                  want software that understands their intent, automates their
                  workflows, and helps them make smarter decisions faster. This
                  is where AI copilots come in. And the good news? You don’t
                  have to be a trillion-dollar company to build one. With the
                  rapid rise of accessible AI models and open-source frameworks,
                  you can build your own AI copilot fully designed for your
                  product and users by hiring an AI copilot development company.
                </p>
              </div>
            </div>
          </div>
        </article>

        {/* cost */}
        <article className="primary__landing-content-container ai_co_mb_80">
          <div className="ai_co_cost">
            <h3 className="ai_co_subtitle text-center">
              <span className="ai_co_span">Cost to Develop </span>
              an AI Copilot
            </h3>
            <p className="ai_co_subcontent text-center">
              The cost of hiring an AI copilot development company depends on
            </p>

            <div className="row gx-4 gy-5 ai_co_cost_row">
              {costFactors.map((factor, index) => (
                <div className="col-lg-4 col-sm-6" key={index}>
                  <div className="ai_co_cost_card">
                    <img
                      src={factor.img}
                      alt="AI Copilot Development Company"
                      className="ai_co_cost_img"
                    />
                    <img
                      src={factor.hoverImg}
                      alt="AI Copilot Development Company"
                      className="ai_co_cost_hoveImg"
                    />
                    <h5>{factor.title}</h5>
                  </div>
                </div>
              ))}
            </div>

            <p className="ai_co_subcontent ai_co_cost_content">
              Project costs typically range between $10,000 and $50,000,
              depending on the complexity and features of the solution.
            </p>
          </div>
        </article>

        {/* hire */}
        <article className="primary__landing-content-container ">
          <div className="row g-4">
            <div className="col-lg-5">
              <h3 className="ai_co_subtitle">
                <div className="ai_co_span">How to hire the Right </div>
                AI Copilot Development Company
              </h3>
              <p className="ai_co_subcontent">
                When selecting an AI copilot development company, consider the
                following
              </p>
            </div>
            <div className="col-lg-7">
              <div className="ai_co_hire_wrap">
                {hireFactors.map((title, index) => (
                  <div className="ai_co_hire" key={index}>
                    <h5>{title}</h5>
                    <span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </article>

        {/* Take Away*/}
        <article className="rs-mt-100 custom-get-in-touch ply-ta">
          <div className="primary__landing-content-container ">
            <h5 className="custom-get-title ph-take-title dt-get-title">
              Take Away
            </h5>
            <p className="custom-get-content dt-get-content">
              Partnering with an experienced AI copilot development company is a
              strategic move for any business looking to boost efficiency,
              enhance user experience, and stay competitive in a rapidly
              evolving market. From automating support to streamlining internal
              operations, AI copilots are reshaping the way organizations work.
            </p>

            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="fiu-need-left-btn mt-4 re-hero-btn"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </article>
      </main>

      {/* faq */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <button
                          className="landing-faq-title collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          What is the role of an AI copilot development company?
                        </button>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          An AI copilot development company builds smart digital
                          assistants tailored to your business needs using AI
                          and machine learning technologies.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          How long does it take to develop an AI copilot?
                        </div>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          It typically takes 1 to 3 months depending on
                          complexity and features. Advanced versions with
                          integrations and learning capabilities may take
                          longer.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          Can an AI copilot integrate with my CRM and ERP?
                        </div>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, most AI copilots are designed to integrate with
                          major platforms like Salesforce, HubSpot, SAP, and
                          others. This enhances workflow efficiency without
                          disrupting your current systems.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq4"
                        >
                          What kind of support can I expect post-deployment?
                        </div>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          A good AI copilot development company offers ongoing
                          monitoring, updates, and support services.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead5">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq5"
                          aria-expanded="true"
                          aria-controls="faq5"
                        >
                          Is my data safe with an AI copilot?
                        </div>
                      </div>

                      <div
                        id="faq5"
                        className="collapse"
                        aria-labelledby="faqhead5"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Absolutely. They are built using secure APIs,
                          encryption protocols, and data privacy best practices.
                          Compliance with industry standards ensures user and
                          enterprise data stays protected.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default AICopilot;
